<template>
    <div class="adActive">
        <!-- <p class="headFont">0原设计</p> -->
        <!-- <div class="topList"> </div> -->
        <!-- <div class="content">
            <div class="flex-row">
                <p class="activeLaber">姓名:</p>
                <input type="text" v-model="name" class="activeInput">
            </div>
            <div class="flex-row">
                <p class="activeLaber">手机号:</p>
                <input type="text" v-model="phone" class="activeInput">
            </div>
            <div class="flex-row" @click=" reasonShow = true">
                <p class="activeLaber">品牌:</p>
                <div type="text" class="activeInput divInput">{{brandActive.name}}</div>
            </div>
        </div> -->
        <div class="content">
            <div class="flex-row contentModule">
                <div class="flex-row" @click=" reasonShow = true">
                    <div type="text" id="myInput1" placeholder="输入姓名" class="activeInputName divInput">{{brandActive.name}}
                        <img :src="icon" class="selectIcon"> 
                    </div>
               </div>
               <div class="flex-row">
                    <input type="text" id="myInput2" placeholder="输入姓名" v-model="name" class="activeInputName">
               </div>
            </div>
            <input type="text" id="myInput3" v-model="phone" class="activeInputPhone" placeholder="输入手机" >
            <div class="activeButton" @click="confirmChange()">抢先领取</div>
        </div>
        
        <van-popup
        v-model="reasonShow"
        position="bottom"
        >
            <van-picker
            show-toolbar
            :columns="brandName"
            @cancel="reasHidePicker"
            @confirm="reasConfirms" 
            />
        </van-popup>
        <!-- <van-popup 
         v-model="selectShow"
         :style="{ height: '100%' }"
         position="top"
         >
            <van-tree-select
            :items="brandList"
            height= 90%
            :active-id="activeId"
            @navclick="onNavClick"
            @itemclick="onItemClick"
            :main-active-index.sync="mainActiveIndex"
            />
            <div class="selectBtn flex-row">
                <p class="reds" @click="blackChange(1, 1)">返回</p>
                <p class="bules" @click="blackChange(2, 1)">确定</p>
            </div>
        </van-popup> -->
    </div>
</template>
<script>
import { listBrand, listCategory, addActivityAppointment } from '@/api/index';
import {  Picker, Popup, TreeSelect, Toast } from 'vant';
import receiving from '@/assets/img/收货@3x.png';
import icon from '@/assets/img/icon_1.jpg';
export default {
    components:{
        [Picker.name] : Picker,
        [Popup.name] : Popup,
        [TreeSelect.name] : TreeSelect,
        [Toast.name] : Toast
    },
    data(){
        return {
            name:'',
            phone: '',
            icon,
            // brandList:[],
            // brandId:[],
            // categoryList:[],
            brandName: [],
            reasonShow: false,
            brandActive: {
                name:'请选择品牌',
                id:[]
            },
            // selectShow: true,
            // activeId:[],
            // mainActiveIndex: 0,

        }
    },
    created(){
        this.getStore();
    },
    mounted(){
      let h = window.innerHeight;
      let myInput1 = document.getElementById('myInput1');
      let myInput2 = document.getElementById('myInput2');
      let myInput3 = document.getElementById('myInput3');
      let Lbody = document.getElementsByClassName('body')
      myInput1.addEventListener('focus',handler,false);
      myInput2.addEventListener('focus',handler,false);
      myInput3.addEventListener('focus',handler,false);

      function handler(){
        //   alert(Lbody.height);
          Lbody.height = h;

      }
    },
    methods:{
        // /**
        //  * 获取品牌
        //  * @method getListCategory
        //  */
        // getListCategory(){
        //     listCategory().then(res=>{
        //         let arr = {
        //             text : '所有品类',
        //             children:[]
        //         };
        //         res.data.forEach(item => {
        //             item.text = item.categoryName;
        //             item.id = item.commodityCategoryId;
        //             arr.children.push(item);

        //         });
        //         this.brandList.push(arr);
        //     }).catch(error=>{
        //         console.log(error);
        //     })
        // },
        /**
         * 获取品牌
         * @method getStore
         */
        getStore(){
            listBrand({brandType: 0}).then(res=>{
                // this.brandList = res.data;
                // let arr = {
                //     text : '所有品牌',
                //     children:[]
                // };
                res.data.forEach(item => {
                    // item.text = item.brandName;
                    // item.id = item.brandId;
                    // arr.children.push(item);
                    this.brandName.push(item.brandName);

                });
                // this.brandList.push(arr);
                // this.getListCategory();
            }).catch(error=> {
                
            })
        },
        // /**
        //  * 品牌索引方法
        //  * @method onNavClick
        //  */
        // onNavClick(index){
        //     this.mainActiveIndex = index;
        // },
        // /**
        //  * 选择品牌返回btn
        //  * @method blackChange
        //  */
        // blackChange(type, info){
        //     if (type == 1){
        //         this.activeId = [];
        //         this.categoryList = [];
        //         this.brandId = [];
        //     }
        //     this.selectShow = false;
        // },
        /**
         * 品牌选择方法
        //  * @method onItemClick
        //  */
        // onItemClick(data){
        //     this.mainActiveIndex ? this.activeId = this.categoryList : this.activeId = this.brandId;
        //     console.log(this.mainActiveIndex)
        //     if( this.activeId.includes(data.id)){
        //         this.activeId.forEach((res,index)=>{
        //             if(res == data.id){
        //                 this.activeId.splice(index, 1);
        //             }
        //         })
        //     }else {
        //         this.activeId.push(data.id);
        //         this.mainActiveIndex ? this.categoryListbrandId = this.activeId : this.brandId = this.activeId;
        //     }
        //     console.log(this.brandId, this.categoryList)
        // },
        /**
         * 选择报修关闭回调
         * @method reasHidePicker
         */
        reasHidePicker(){
            this.reasonShow = false
        },
        /**
         * 选择报销确定change
         * @method reasConfirms
         */
        reasConfirms(value, i){
            this.brandActive.name = value;
             this.brandActive.id = [];
              this.brandActive.id.push(i);
            this.reasonShow = false;
        },
        /**
         * 选择门店Show
         * @method storeShow
         */
        storeShow(){
            this.reasonShow = true;
        },
        /**
         * 提交方法
         * @method confirmChange
         */
        confirmChange(){
            let phone = this.$loca.getItem('phone');
            let name = this.$loca.getItem('name');
            let data= {
                appointmentType: 0,
                phone: phone,
                name: name,
                appointmentPhone: this.phone,
                appointmentName: this.name,
                activityId: '',
                storeId:'',
                brandIds: this.brandActive.id
            }
            addActivityAppointment(data).then(res=>{
                if(res.status == 200){
                    if(this.name == '' || this.phone == '' || this.brandActive.name == '请选择品牌'){
                        Toast.success('请填写完整信息');
                    }else {
                        Toast.success('报名成功');
                        this.$router.push({path:'/'});
                    }

                }
            }).catch(error=>{

            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .adActive{
        position: relative;
        background-image:url("../../assets/img/activeBg.jpg");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width:100vw;
        height: 100%;
        .headFont{
            text-align: center;
            color: #ffffff;

        }
        // .topList{
        //     height: 40%;
        // }
        .content{
            position:absolute;
            top: 41%;
            z-index: 9999;
            background: #FFD0D0;
            box-shadow:-1px 3px 22px 5px rgba(223,109,109,0.73);
            padding: 56px 35px 67px 35px ;
            margin-left: 45px;
            width: 588px;
            border-radius: 16px;
            .activeInput{
                border:2px solid #ebebeb;
                border-radius: 5px; 
                width: 100%;
                height: 60px;
            }
            .activeLaber{
                width: 150px;
                font-size: 28px;
            }
        }
    }
    .contentModule{
        align-items: center;
        margin-bottom: 43px;
    }
    .activeButton{
        text-align: center;
        background:rgba(244,90,90,1);
        color: #ffffff;
        height: 86px;
        font-size:32px;
        margin-top: 98px;
        line-height: 86px;
        border-radius: 10px;
    }
    .activeModel{
        line-height: 60px;
        padding-left: 20px;
    }
    .selectBtn{
        height: 10%;
        z-index: 999px;
        justify-content: space-around;
        text-align: center;
        
        color: #ffffff;
        .reds{
            background: #F56C6C;
            flex: 1;
            height: 100%;
            line-height: 6;
            font-size: 32px;
            line-height: 4.5;
        }
        .bules{
            background: #409EFF;
            flex:1;
            height: 100%;
            font-size: 32px;
            line-height: 4.5;
        }
    }
    .divInput{
        line-height: 60px;
    }
    .activeInputPhone{
        height: 79px;
        width: calc(100% - 35px);
        border-radius:8px;
        background:rgba(255,255,255,1);
        padding-left: 35px;
        line-height: 79px;
        color:rgba(190,89,89,1);
        font-size:29px;        
    }
    .activeInputName{
        height: 79px;
        width: 245px;
        border-radius:8px;
        background:rgba(255,255,255,1);
        padding-left: 35px;
        line-height: 79px;
        color:rgba(190,89,89,1);
        font-size:29px;
        position: relative;
    }
    .contentModule{
        justify-content: space-between;
    }
    ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
        color:rgba(190,89,89,1);
        font-size:29px;
    }
    :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        opacity:  1;
        color:rgba(190,89,89,1);
        font-size:29px;
    }
    ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color:rgba(190,89,89,1);
        opacity:  1;
        font-size:29px;
    }
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color:rgba(190,89,89,1);
        font-size:29px;
    }
    .selectIcon{
        width:14px;
        height:12px;
        position: absolute;
        top: 37px;
        right: 18px;
    }
</style>

